import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
// import { components } from 'react-select'
// import { travelBrandsService } from '../../_services/TravelBrands.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

const data = [
  {label: '5', value: 5},
  {label: '10' , value: 10},
  {label: '20' , value: 20},
  {label: '30' , value: 30},
  {label: '50' , value: 50},
  {label: '100' , value: 100},
  {label: '200' , value: 200},
]

class PageSize extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      defaultValue: ''
    };
  }

  handleChange = e =>{
    this.props.onChange(e.value);
  }

  render() {
    const customStyles = {
      // option: (provided, state) => ({
      //   ...provided,
      //
      // }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#fff',
        borderRadius: 20,
        boxShadow: 'none',
        paddingRight: '12',
        margin: '20px 0',
        direction: 'ltr'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading } = this.state;
    const { disabled, required } = this.props;

    return (
      <div>
        {!loading &&
          <Select
            isDisabled={disabled}
            placeholder="تعداد نمایش"
            styles={customStyles}
            options={data}
            onChange={this.handleChange}
            value={this.props.defaultValue}
            className={required ? "select required" : "select"}
            />
        }
      </div>
    );
  }
}
export default PageSize;
